import React from 'react';
import ATable from '../../common/table';

const TransactionTypesTable = (props) => {
    
 
    const columns = [{
        header: "S/N",
        width: 50,
        render :  row => (<div>{row.viewIndex + 1}</div>)
    }, 
    {
        header: "Name",
        accessor: "name",
        width :250
    },
    {
        header: "Transaction Group",
        accessor: "group",
    },
    {
        header: "Disputable Response Codes",
        accessor: "disputableResponseCodes",
        render: row => { return (row.row.disputableResponseCodes ? row.row.disputableResponseCodes.join(",") : "") },
        width : 300
    }
    ];
    return (
            <ATable
                className="-striped -highlight"
                    tableData={props.transactionTypes}
                    columns={columns}
                    onChange={props.onTableChange || null}
                    
                    manual
                    {...props} />
    )
};

export default TransactionTypesTable;


// WEBPACK FOOTER //
// ./src/components/admin/transactionTypes/transactionTypesTable.js